<template>
  <div class="mapview">
    <baidu-map class="bmview" :center="center" :zoom="zoom" @ready="handler" :scroll-wheel-zoom="true" :pinch-to-zoom="true" :dragging="true" :ak="ak">
      <bm-local-search :location="location" :keyword="searchString" :auto-viewport="true" :panel="true" @infohtmlset="localClick"></bm-local-search>
      <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-navigation>
    </baidu-map>

    <div class="search-posi">
      <div class="posi-box">
        <span class="posi-desc">搜索处:</span>
        <el-input v-model="searchString" placeholder="关键字" style="width:100%"></el-input>
      </div>

      <div class="posi-box">
        <span class="posi-desc">显示处:</span>
        <el-input class="markpoint" v-model="addressText" readonly placeholder="标点的地址"></el-input>
      </div>

      <div>
        <el-button size="small" type="primary" @click="comfirm">确认</el-button>
        <el-button size="small" @click="toBack">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
import BmGeolocation from 'vue-baidu-map/components/controls/Geolocation.vue';
import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch.vue';
import BmCircle from 'vue-baidu-map/components/overlays/Circle.vue';
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue';
import BmLabel from 'vue-baidu-map/components/overlays/Label.vue';
import BmNavigation from 'vue-baidu-map/components/controls/Navigation.vue';
import { Toast, Dialog } from 'vant';
import { mapState } from 'vuex';
import locationUtils from '../utils/geoTran.js';
import fetchJsonp from 'fetch-jsonp';

export default {
  name: 'MapView',
  components: {
    BaiduMap,
    BmGeolocation,
    BmLocalSearch,
    BmMarker,
    BmLabel,
    BmCircle,
    BmNavigation
  },
  props: {
    position: {
      type: Object
    }
  },
  data() {
    return {
      ak: 'dcsylBb7nOrDMqsh0K0uekos9WoGGr8C',
      center: { lng: 114.044815, lat: 22.561407 },
      zoom: 18,
      BMap: null,
      map: null,
      searchString: '华瀚',
      location: '深圳市',
      mapshow: false,
      addressText: ''
    };
  },
  methods: {
    getDeviceInfo() {
      //获取设备参数
      let that = this;
      if ('geolocation' in window.navigator) {
        /* 地理位置服务可用 */
        let geo = window.navigator.geolocation.getCurrentPosition(
          function(position) {
            console.log(position.coords.latitude, position.coords.longitude);
            let g = locationUtils.wgs84Tobd09(position.coords.latitude, position.coords.longitude);
            console.log(g);
            that.center.lng = g[1];
            that.center.lat = g[0];
            that.getAddress(g[1], g[0]);
          },
          function(err) {
            // 获取失败
          }
        );
      } else {
        /* 地理位置服务不可用 */
        Dialog({ message: '无法获取定位，请检查定位权限或者移动选择地点！' });
      }
    },

    set_bmview_CSS() {
      let deviceNparam = window.screen;
      let w = deviceNparam.width;
      let h = deviceNparam.height;
      window.document.getElementsByClassName('bmview')[0].style.height = h - 200 + 'px';
      window.document.getElementsByClassName('bmview')[0].style.width = w + 'px';
    },

    handler({ BMap, map }) {
      let that = this;
      that.BMap = BMap;
      that.map = map;
      that.set_bmview_CSS();
      that.getDeviceInfo();
    },

    getAddress(lng, lat) {
      let that = this;
      console.log(window.BMap);
      let myGeo = new window.BMap.Geocoder();
      let p = new window.BMap.Point(lng, lat);
      myGeo.getLocation(p, function(result) {
        let strarr = result.addressComponents;
        that.location = strarr.city;
        console.log(that.location);
      });
    },

    localClick(e) {
      this.addressText = e.address;
      this.checkData = e;
    },
    comfirm() {
      if (!this.addressText) {
        Toast({ message: '请在地址面板中选择一个地址' });
        return;
      }

      this.$store.commit('setAddressData', this.checkData);
      this.toBack();
    },
    toBack() {
      window.history.back();
    }
  },
  watch: {},
  computed: {
    ...mapState(['point', 'address'])
  },
  beforeCreate() {
    //console.log(1);
    //在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用
  },
  created() {
    //实例已经创建完成之后被调用。在这一步，实例已完成以下的配置：数据观测(data observer)，属性和方法的运算， watch/event 事件回调。
    //然而，挂载阶段还没开始，$el 属性目前不可见。
    //可以在组件的这个期间请求数据，如果是keep-alive组件会被缓存起来，生命周期不会再次触发，如果需要更新数据可以watch当前router变化，如果router是当前组件所在的router则请求数据
    //console.log(2);
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用
    //console.log(3);
  },
  mounted() {
    //vm.$el已挂载在文档内，对已有dom节点的操作可以在这期间进行

    let that = this;

    window.onresize = function() {
      that.set_bmview_CSS();
    };
  },
  beforeUpdate() {
    //数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程
    //console.log(5);
  },
  updated() {
    //由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    //当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。然而在大多数情况下，你应该避免在此期间更改状态，因为这可能会导致更新无限循环。
    //console.log(6);
  },
  activated() {
    //keep-alive 组件激活时调用
    //console.log(7);
  },
  deactivated() {
    //keep-alive 组件停用时调用
    //console.log(8);
  },
  beforeDestroy() {
    //实例销毁之前调用。在这一步，实例仍然完全可用
    //console.log(9);
  },
  destroyed() {
    //Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁
    //console.log(10);
  }
};
</script>

<style lang="less" scoped>
.search-posi {
  position: absolute;
  top: 10px;
  width: 100%;
  padding: 0 20px;
}
.posi-box {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 0 10px;
  width: 100%;
  margin-bottom: 10px;
  height: 50px;
}
.posi-desc {
  display: inline-block;
  width: 80px;
}
.markpoint {
  margin: 6px 0;
}
</style>
>
